import { supportedLangs } from '@geartracker/types';
import { capitalizeFirstLetter } from '@geartracker/utils';

import { createZodDto } from './zod';

import { z } from 'zod';

const emailSchema = z.string().trim().toLowerCase().pipe(z.email());

const getLoginOptionsSchema = z.object({
  email: emailSchema,
});

const LoginSchema = z.object({
  email: emailSchema,
  password: z.string().min(8).max(64), // min 8 to support legacy users
});

const CompleteProfileSchema = z.object({
  firstName: z.string().transform(capitalizeFirstLetter).nullable(),
  lastName: z.string().transform(capitalizeFirstLetter).nullable(),
  organizationName: z.string().transform(capitalizeFirstLetter).nullable(),
  phone: z.string().trim().nullable(),
  language: z.enum(supportedLangs),
  organizationIndustry: z.string().nullable(),
});

const RegisterEmailSchema = z.object({
  email: emailSchema,
  language: z.enum(supportedLangs),
  /** Auto means the registration is done automatically without user interaction, coming from a marketing link*/
  mode: z.enum(['normal', 'fileAccess']).optional(),
});

const continueWithGoogleSchema = z.object({
  token: z.string(),
  language: z.enum(supportedLangs),
  platform: z.enum(['ios', 'android', 'web']),
});

const continueWithAppleSchema = z.object({
  idToken: z.string(),
  firstName: z.string().optional().nullable(),
  lastName: z.string().optional().nullable(),
  language: z.enum(supportedLangs),
  platform: z.enum(['ios', 'android', 'web']),
});

const TokenSchema = z.object({
  token: z.string(),
});

const TokenWithEmailSchema = z.object({
  token: z.string(),
  email: emailSchema,
});

const RetrievePasswordSchema = z.object({
  email: emailSchema,
});

const UpdatePasswordWithTokenSchema = z.object({
  token: z.string(),
  password: z.string().min(8).max(64),
});

export class LoginDto extends createZodDto(LoginSchema) {}

export class CompleteProfileDto extends createZodDto(CompleteProfileSchema) {}

export class RegisterEmailDto extends createZodDto(RegisterEmailSchema) {}

export class ContinueWithGoogleDto extends createZodDto(
  continueWithGoogleSchema,
) {}

export class ContinueWithAppleDto extends createZodDto(
  continueWithAppleSchema,
) {}

export class TokenDto extends createZodDto(TokenSchema) {}

export class TokenWithEmailDto extends createZodDto(TokenWithEmailSchema) {}

export class RetrievePasswordDto extends createZodDto(RetrievePasswordSchema) {}

export class UpdatePasswordWithTokenDto extends createZodDto(
  UpdatePasswordWithTokenSchema,
) {}

export class GetLoginOptionsDto extends createZodDto(getLoginOptionsSchema) {}
